export const App = () => {
  return <div className="app">App</div>;
};
